// extracted by mini-css-extract-plugin
export default {"wrapper":"RulesPageTableFactorCell_wrapper__QqVvn","input-group":"RulesPageTableFactorCell_input-group__Clkt3"};